const BASE = "https://customer-assets-gfyr7b9c.emergentagent.net/job_1305c39b-0b7e-4532-8b9e-9792b12bd18f/artifacts";

export const IMG = {
  ladies: `${BASE}/41a879dda2d5259c_IMG_1541.jpeg`,
  guy: `${BASE}/0a4fe22eb31a6d71_A92899A5-8F76-4483-A1E3-5ABDCD594012.jpeg`,
  hatFront: `${BASE}/63ae067a500952ee_IMG_0578.jpeg`,
  hatAngle: `${BASE}/e772382b9db675fd_IMG_0579.jpeg`,
  hatSide: `${BASE}/dc158bde912fdd4d_IMG_0580.jpeg`,
  hatPile: "/assets/hat-pile.jpg",
  stayLit: "/assets/staylit.jpg",
  jersey: "/assets/jersey-white.jpg",
  xMark: "/favicon-x.png",
  xRed: "/assets/x-red.png",
};

export const LOGO_URL = "/assets/logo-sm.png";

export const HAT_GALLERY = [
  { src: IMG.hatFront, label: "Front" },
  { src: IMG.hatAngle, label: "Angle" },
  { src: IMG.hatSide, label: "Side #X" },
  { src: IMG.hatPile, label: "The Stack" },
];
